// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"53d7c03f","882":"53d7c03f"}[chunkId] + ".chunk.css";
};